export enum DeployEnvironmentEnum {
  Production = 'production',
  Staging = 'staging',
  Development = 'development',
  Local = 'local'
}
